<template>
  <div class="cover center">
    <div class="flex content">
      <div class="logo-box">
        <img src="/static/intr.png" />
      </div>
      <div class="intr-info">
        <h1 class="center" style="margin-top: 3rem">關於我們</h1>
        <p>
          &nbsp;
          <!-- “儒藏（精华编）数字化平台”依托《儒藏》工程巨大的资源优势，利用数字技术将《儒藏》（精华编）经过校勘整理后的文献资料全文数字化和结构化，建设专业规范、自成系统的在线全文数据库，忠实呈现纸质图书文本，为全世界各国学者提供文献阅读、学术检索、比对分析等服务，借助科技手段将《儒藏》文献价值最大化。 -->
          “儒藏（精華編）數字化平臺”依託《儒藏》工程巨大的資源優勢，利用數字技術將《儒藏》（精華編）經過校勘整理後的文獻資料全文數字化和結構化，建設專業規範、自成系統的在綫全文數據庫，忠實呈現紙質圖書文本，爲全世界各國學者提供文獻閲讀、學術檢索、對比分析等服務，藉助科技手段將《儒藏》文獻價值最大化。
        </p>
        <h1 class="center" style="margin-top: 6rem">聯繫我們</h1>
        <p class="rows">
          <!-- 电子邮箱：service@pup.cn -->
          電子郵箱：<span class="rowfont">service@pup.cn</span>
        </p>
        <p class="rows">
          <!-- 通讯地址：北京市海淀区成府路205号（邮编：100871） -->
          通信地址：北京市海淀區成府路<span class="rowfont">205</span>號（郵編：<span class="rowfont">100871</span>）
        </p>
        <p class="rows">
          <!-- 联系电话：010-62757513（服务时间：周一至周五8:30-12:00，13:30-17:00） -->
          聯繫電話：<span class="rowfont">010-62757513</span>（服務時間：周一至周五<span class="rowfont">8:30—12:00</span>，<span class="rowfont">13:30—17:00</span>）
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { readHistory } from "@/api/api";
export default {
  name: "WordTest",
  components: {}
};
</script>

<style lang="less" scoped>
.cover {
  margin: 0 auto;
  padding: 3rem 0;
  .content {
    width: 1200px;
    height: 100%;
    display: flex;
    .logo-box {
      width: 300px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .intr-info {
      width: 800px;
      padding-left: 4rem;
      line-height: 1.5;
      font-size: 20px;
    }

    .row {
      margin-top: 48rpx;
       font-family: "Arial, Helvetica, sans-serif";
    }
    .rowfont{
      font-family: "Arial, Helvetica, sans-serif";
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/intrInfo/index.vue